export default {
  loading_menu: 'Ładowanie menu...',
};
